import React, { useState } from 'react';
import {
  Nav,
  Row,
  Tab,
} from 'react-bootstrap';

import useListHomeWarnings from 'hooks/Home/useListHomeWarnings';
import MeteorologyStatus from 'components/NewHome/Table/MeteorologyStatus';
import FluxQueue from 'components/NewHome/Table/FluxQueue';
import FluxStatus from 'components/NewHome/Table/FluxStatus';
import Warnings from 'components/NewHome/Table/Warnings';

import './index.scss';

export default function HomeTabs() {
  const [key, setKey] = useState('meteorology-status');
  const {
    warnings,
    refetch,
    showNotification,
    updateLastSeen,
  } = useListHomeWarnings();
  const warningsVisible = (key === 'warnings');
  const showWarningBadge = (showNotification && !warningsVisible);

  return (
    <div className="tabbed-page home-table">
      <Tab.Container activeKey={key} onSelect={(k) => setKey(k as string)} id="home-tabs">
        <Row>
          <Nav variant="tabs gap-1">
            <Nav.Item>
              <Nav.Link eventKey="meteorology-status">STATUS METEOROLOGIA</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="flux-status">STATUS FLUX</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="flux-queue">FILA FLUX</Nav.Link>
            </Nav.Item>
            <Nav.Item className="position-relative">
              <Nav.Link eventKey="warnings">AVISOS</Nav.Link>
              {showWarningBadge && <span className="new-warning-badge">!</span>}
            </Nav.Item>
          </Nav>
        </Row>
        <Row>
          <Tab.Content>
            <Tab.Pane eventKey="meteorology-status">
              <MeteorologyStatus />
            </Tab.Pane>
            <Tab.Pane eventKey="flux-status">
              <FluxStatus />
            </Tab.Pane>
            <Tab.Pane eventKey="flux-queue">
              <FluxQueue />
            </Tab.Pane>
            <Tab.Pane eventKey="warnings">
              <Warnings
                warnings={warnings}
                visible={warningsVisible}
                updateLastSeen={updateLastSeen}
                refetch={refetch}
              />
            </Tab.Pane>
          </Tab.Content>
        </Row>
      </Tab.Container>
    </div>
  );
}
